// extracted by mini-css-extract-plugin
export default {"messageIcon":"Vsdm9PBxzeWp6DzGbOyH","MessageUserButton":"l8TCvqtLuaGus3UY1sDS","defaultButton":"TifBA7cU83dE8jVZTFLA","linkButton":"_hsM6RxQHpZzP41DyeWt"};